<template>
  <div>
    <div class="row">
      <div class="col-lg-9 col-md-12">
        <card class="shadow-lg">
          <div class="row content-add-btn padbtn">
            <button class="btn btn-secondary" @click="$router.go(-1);">
              <i class="fa fa-chevron-left"></i>
              Regresar
            </button>
          </div>
          <hr />
          <form v-if="canCreate() || canUpdate()" @submit.prevent="validateForm">
            <div class="row">
              <div class="col-md-6">
                <fg-input
                type="text"
                label="NIT *"
                v-model="companieForm.nit"
                v-validate="modelValidations.nit"
                name="nit"
                :error="getError('nit')"
                :disabled="disabledField">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input
                type="text"
                label="Nombre *"
                v-model="companieForm.company"
                v-validate="modelValidations.company"
                name="nombre"
                :error="getError('nombre')"
                :disabled="disabledField">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fg-input
                type="text"
                label="Dirección"
                v-model="companieForm.address">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input
                type="email"
                label="Correo"
                v-model="companieForm.email">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fg-input
                type="text"
                label="Telefono"
                v-model="companieForm.phone">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input
                type="text"
                label="Sitio Web"
                v-model="companieForm.web_site">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label>Departamentos</label>
                <el-select  multiple class="select-primary select_modules"
                v-model="companieForm.departments"
                filterable placeholder="Seleccione uno o varios departamentos">
                  <el-option v-for="option in departments"
                              class="select-primary"
                              :value="option.id"
                              :label="option.department"
                              :key="option.department">
                  </el-option>
                </el-select>
              </div>
            </div><br><hr><br>
            <div class="text-center">
              <button type="submit" class="btn btn-fill btn-warning btn-wd">
                Guardar
              </button>
            </div>
          </form>
          <div v-else>
            <div class="text-center">
              <h4> <strong> No tienes permiso para crear o editar </strong></h4>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'

  export default {
    data () {
      return {
        companieForm: {
          nit: null,
          company: null,
          address: null,
          email: null,
          phone: null,
          web_site: null,
          departments: null,
        },
        departments: null,
        modelValidations: {
          nit: {
            required: true,
          },
          company: {
            required: true,
          },
        },
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods:{
      validateForm(name){
        this.$validator.validateAll().then(isValid => {
          if(isValid) this.storeUpdateCompanie()
        })
      },
      storeUpdateCompanie(){
        this.$emit('cotentLoading', true)                  
        this.companieForm.route = 'companies'
        if (localStorage.getItem('companieEdit')) {
          this.updateMaster(this.companieForm).then((response)=>{
            this.$emit('cotentLoading')          
            showSwalAlert(response.data.message, 'success', false).then(() => this.$router.push('/companies'))
          }).catch((error) => this.showMessageErrors(error))
        } else {
          this.saveMaster(this.companieForm).then((response)=>{
            this.$emit('cotentLoading')          
            showSwalAlert(response.data.message, 'success', false).then(() => this.$router.push('/companies'))
          }).catch((error) => this.showMessageErrors(error))
        }
      },
    },
    created(){
      if(this.canCreate() || this.canUpdate()){
        if (localStorage.getItem('companieEdit')) {
          this.$emit('cotentLoading', true)          

          setTimeout(() => {
            this.disabledField = true
            this.companieForm = JSON.parse(localStorage.getItem('companieEdit'))
            this.title = 'Editar Empresa '+this.companieForm.company
            this.$emit('cotentLoading')                      
          }, 1000);
        }
        else {
          this.title = 'Agregar una Empresa'
        }
        this.getMasters('departments/index').then((response) => {
          this.departments = response.data.data
        })
      }
    },
    beforeDestroy(){
      localStorage.removeItem('companieEdit');
    }
  }
</script>
